import { featuredStory } from "@/pages/home/data";

const TICKER = [
  "今日 09:00 · 编辑部已发布《一档爆款真人秀的“剧本感”，到底从哪来》",
  "新增栏目 · “细节深挖”已收录 57 篇线索型稿件",
  "看吃瓜周报 · 每周五发送本周事件脉络汇总",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      <img
        src={featuredStory.image}
        alt={featuredStory.alt}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/55 to-foreground-950/90"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-transparent to-foreground-950/40"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col justify-end px-4 pb-14 pt-32 md:px-6 md:pt-40 md:pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
            <span className="h-1.5 w-1.5 rounded-full bg-background-50/90"></span>
            {featuredStory.tag}
          </div>

          <h2 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-tight">
            {featuredStory.title}
          </h2>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            {featuredStory.dek}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-background-100/80">
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line" aria-hidden="true"></i>
              {featuredStory.date}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line" aria-hidden="true"></i>
              {featuredStory.readTime}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-user-3-line" aria-hidden="true"></i>
              编辑部 · 看吃瓜
            </span>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#truth"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              查看事件脉络时间线
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#picks"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/70 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              继续往下深扒
            </a>
          </div>
        </div>
      </div>

      {/* 底部滚动条 */}
      <div className="relative border-t border-background-50/15 bg-foreground-950/60 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-6 overflow-hidden px-4 py-2.5 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-bold tracking-wide text-accent-400">
            <i className="ri-broadcast-line text-base" aria-hidden="true"></i>
            编辑快讯
          </span>
          <span className="hidden h-4 w-px shrink-0 bg-background-50/20 sm:block"></span>
          <div className="flex min-w-0 flex-1 items-center gap-6 overflow-hidden">
            {TICKER.map((text, i) => (
              <span key={i} className="whitespace-nowrap text-xs text-background-100/80">
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}